module.exports = __webpack_public_path__ + "img/cote-pc-0218-02.704100c8.png";